import { Outlet } from 'react-router-dom';
import { InstallBanner } from '@/components/common';

export function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-admin-bg p-4">
      <InstallBanner />
      <Outlet />
    </div>
  );
}
